import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "tile-outer" }
const _hoisted_3 = { class: "tile-inner" }
const _hoisted_4 = { class: "tile-content" }
const _hoisted_5 = { "data-test": "resource-tile-title" }

import { ref, Ref, inject } from "vue";
import { debug as d } from "debug";
import { CmsImage } from "../../services/cms/cms-type-definitions";
import CmsImg from "./cms-img.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'resource-tile',
  props: {
    title: { default: "" },
    href: { default: "javacript:void(0)" },
    src: { default: null }
  },
  setup(__props: any) {

const debug = d("cs.ResourceTile");

const cmsTileImage = inject("cmsTileImage", null) as Ref<InstanceType<typeof CmsImg> | null> | null;

const props = __props;

const tileImage = ref<InstanceType<typeof CmsImg> | null>(null);

const triggerAnimation = (): void => {
  if (tileImage.value) {
    tileImage.value.animate(true);
  } else if (cmsTileImage?.value) {
    // This handles special case when a CmsImg component
    // is passed by a parent to this component's <slot>
    cmsTileImage.value?.animate(true);
  } else {
    debug("No tile image found to animate");
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    href: _ctx.href,
    class: "resource-tile",
    onMouseenter: triggerAnimation,
    onFocus: triggerAnimation
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "default", {}, () => [
            (_ctx.src)
              ? (_openBlock(), _createBlock(CmsImg, {
                  key: 0,
                  src: _ctx.src,
                  ref_key: "tileImage",
                  ref: tileImage
                }, null, 8, ["src"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.title), 1)
  ], 40, _hoisted_1))
}
}

})